var _defs, _g, _path, _path2, _path3, _path4, _path5, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrgCongresos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #1d1d1b;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.87,325.48H127c-15.91,0-28.85-12.95-28.85-28.85V89.58c0-15.91,12.95-28.85,28.85-28.85h35.42v12.17h-35.42c-9.21,0-16.68,7.49-16.68,16.68v207.05c0,9.21,7.47,16.68,16.68,16.68h159.82c3.11,4.58,6.77,8.79,11.05,12.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.96,
    y: 60.72,
    width: 63.88,
    height: 12.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 265.39,
    y: 60.72,
    width: 63.88,
    height: 12.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M411.59,89.58v181.9c-2.84-9.73-7.37-18.77-12.17-27.66V89.58c0-9.19-7.47-16.68-16.65-16.68h-33.96v-12.17h33.96c15.91,0,28.83,12.95,28.83,28.85Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.18,29.01c-12.07,0-21.93,9.86-21.93,21.96v31.72c0,12.1,9.86,21.93,21.93,21.93s21.96-9.83,21.96-21.93v-31.72c0-12.1-9.86-21.96-21.96-21.96Zm9.78,53.67c0,5.38-4.38,9.76-9.78,9.76s-9.76-4.38-9.76-9.76v-31.72c0-5.4,4.38-9.78,9.76-9.78s9.78,4.38,9.78,9.78v31.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.6,29.01c-12.1,0-21.93,9.86-21.93,21.96v31.72c0,12.1,9.83,21.93,21.96,21.93s21.93-9.83,21.93-21.93v-31.72c0-12.1-9.86-21.96-21.96-21.96Zm9.78,53.67c0,5.38-4.38,9.76-9.76,9.76h-.02c-5.38,0-9.76-4.38-9.76-9.76v-31.72c0-5.4,4.38-9.78,9.78-9.78s9.76,4.38,9.76,9.78v31.72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.02,29.01c-12.07,0-21.93,9.86-21.93,21.96v31.72c0,12.1,9.86,21.93,21.93,21.93s21.96-9.83,21.96-21.93v-31.72c0-12.1-9.86-21.96-21.96-21.96Zm9.78,53.67c0,5.38-4.38,9.76-9.78,9.76s-9.76-4.38-9.76-9.76v-31.72c0-5.4,4.38-9.78,9.76-9.78s9.78,4.38,9.78,9.78v31.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.78,346.99c-38.64,0-70.08-31.43-70.08-70.08s31.44-70.08,70.08-70.08,70.08,31.43,70.08,70.08-31.44,70.08-70.08,70.08Zm0-127.98c-31.93,0-57.91,25.98-57.91,57.91s25.98,57.91,57.91,57.91,57.91-25.98,57.91-57.91-25.98-57.91-57.91-57.91Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.9,308.79l-23.74-22.71c-2.43-2.32-2.51-6.17-.19-8.6h0c2.32-2.43,6.17-2.51,8.6-.19l15.14,14.48c1.23,1.18,3.18,1.16,4.38-.05l34.63-34.63c2.38-2.38,6.23-2.38,8.6,0h0c2.38,2.38,2.38,6.23,0,8.6l-43.04,43.05c-1.2,1.2-3.15,1.23-4.38,.05Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 103.83,
    y: 122.65,
    width: 302.36,
    height: 12.17
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgCongresos);
export default __webpack_public_path__ + "static/media/org_congresos.7892d1bd0bfb2ecf59f11f92335790fb.svg";
export { ForwardRef as ReactComponent };